
async function getAddressByZipcode(zip_code) {
  const params = {
    zip_code: zip_code,
  };
  const queryParams = new URLSearchParams(params);

  return fetch('/api/address_search_by_zipcode?' + queryParams
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { getAddressByZipcode }
